import {
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
	Modal,
} from '../../components';
import styles from '../../assets/styles/Settings/Settings.module.scss';
import { userStore } from '../../stores';
import { Formik } from 'formik';
import React from 'react';

const Security = ({
	closeModal,
	passwordChange,
	securityQuestions,
	goToPasswordChange,
	loading,
	goToSetPin,
	pinSet,
	hasPin,
	onSubmitChangePin,
	onSubmitSetPin,
	onSubmitChangePassword,
	changePinValidationSchema,
	changePasswordValidationSchema,
	setPinValidationSchema,
	pinChange,
	goBack,
	goToPinChange,
}) => {
	return (
		<Modal closeModal={closeModal} goBack={goBack}>		

			
				<div>
					<MimaText mb={3} color="var(--color-primary)" align="center">
						Change your password
					</MimaText>
					<Formik
						initialValues={{
							password: '',
							newPassword: '',
							confirmNewPassword: '',
						}}
						validationSchema={changePasswordValidationSchema}
						onSubmit={onSubmitChangePassword}
					>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							values,
							errors,
							touched,
							setFieldValue,
						}) => (
							<>
								<div className={styles.bus__details}>
									<MimaInput
										type="text"
										labelTitle="Current Password"
										name="password"
										value={values.password}
										onChange={handleChange}
										onBlur={handleBlur}
										passwordIcon
										placeholder="Enter current password"
										error={errors.password}
										touched={touched.password}
									/>
									<MimaInput
										type="text"
										labelTitle="New Password"
										name="newPassword"
										value={values.newPassword}
										onChange={handleChange}
										onBlur={handleBlur}
										passwordIcon
										placeholder="Enter new current password"
										error={errors.newPassword}
										touched={touched.newPassword}
									/>
									<MimaInput
										type="text"
										labelTitle="Confirm New Password"
										name="confirmNewPassword"
										value={values.confirmNewPassword}
										onChange={handleChange}
										onBlur={handleBlur}
										passwordIcon
										placeholder="Confirm new password"
										error={errors.confirmNewPassword}
										touched={touched.confirmNewPassword}
									/>

									<MimaButton
										disabled={loading}
										loading={loading}
										title="Change Password"
										type="submit"
										onClick={handleSubmit}
                                        width={38}
                                        mt={4}
									/>
								</div>
							</>
						)}
					</Formik>
				</div>		
			
		</Modal>
	);
};

export default Security;
